import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import { RecordApprovalMutation } from '@/lib/gql/__generated__/canonical-documents';
import type { RecordApprovalInput } from '@/lib/gql/__generated__/graphql';

export const recordApprovalActor = fromPromise<boolean, RecordApprovalInput>(async ({ input }) => {
  const result = await apolloClient.mutate({
    mutation: RecordApprovalMutation,
    variables: {
      input: {
        approvalId: input.approvalId,
        filingId: input.filingId,
      },
    },
  });

  if (!result.data?.recordApproval.success) {
    throw new Error(result.data?.recordApproval.error?.message ?? 'The approval could not be recorded.');
  }
  return true;
});
